/* ------------ TABLE CONFIGURATION ------------ */

export interface QuestionnairePhq9 {
  position: number;
  question: string;
}

export const Q_PHQ_9: QuestionnairePhq9[] = [
  {
    position: 0, question: 'Durante le ultime due settimane, per quanti giorni...'
  },
  {
    position: 1, question: 'a) ...ha provato poco interesse o piacere nel fare le cose?'
  },
  {
    position: 2, question: 'b) ...si è sentito/a giù di morale, depresso/a, senza speranze?',
  },
  {
    position: 3, question: 'c) ...ha avuto problemi nell’addormentarsi, o nel rimanere addormentato, o ha dormito troppo?',
  },
  {
    position: 4, question: 'd) ...ha avuto  sensazione di stanchezza o di poca energia?',
  },
  {
    position: 5, question: 'e) ...ha avuto poco appetito o mangiato troppo ?'
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 6, question: 'f) ...si è sentito arrabbiato con se stesso, o di essere un fallito, o di avere danneggiato se stesso o la sua famiglia?',
  },
  {
    position: 7, question: 'g) ...ha avuto difficoltà a concentrarsi su qualcosa, ad esempio leggere il giornale o guardare la TV?',
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 8, question: 'h) ...ha avuto movimenti o parole talmente lenti da poter essere stati notati dagli altri. O, al contrario, è stato talmente irrequieto e instancabile, da muoversi molto più del solito?',
  },
  {
    position: 9, question: 'i) ...ha pensato che sarebbe meglio essere morto, di farsi del male in qualche modo?',
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 10, question: 'Se il paziente riporta uno o più disturbi, chiedere quanto questi problemi abbiano reso difficile fare il suo lavoro, occuparsi delle sue cose a casa, stare insieme agli altri:',
  },
];


export class PHQ9Results {
  doctorID: string;
  patientSSN: string;
  results: string[];
  finalScore: number;


  constructor(doctorID: string, patientSSN: string, results: string[], finalScore: number) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
    this.finalScore = finalScore;
  }
}
